export default "__VITE_ASSET__CWorwX4C__"